
function keyDownFunction(e: any) {
  if (e.keyCode === 38 || e.keyCode === 40 || e.code === "Space") {
    e.preventDefault();
  }
}

function getTokenData() {
  // @ts-ignore
  try {
    let localData = localStorage.getItem("w_token");
    const token = localData ? JSON.parse(localStorage.getItem("w_token") || "") : '';
    if (token !== null) {
      return token;

    } else {
      return null;
    }
  } catch (error) {
    alert("Please enable the cookies in your browser setting.")
  }
}

function nFormatter(num: number) {
  if (num >= 1000) {
    return (num / 1000).toFixed(2).replace(/\.0$/, '') + 'K';
  }
  return num;
}

function betValidation(data: any) {
  let res = {
    message: '',
    status: false
  }
  if (data?.amount > data?.wallet) {
    res['message'] = 'Insufficiant Balance';
    res['status'] = false;
    return res;
  }
  if (data?.type !== 'odds') {
    if (data?.amount < data?.min) {
      res['message'] = 'Min amount : ' + data?.min;
      res['status'] = false;
      return res;
    }
    if (data?.amount > data?.max) {
      res['message'] = 'Max amount : ' + data?.max;
      res['status'] = false;
      return res;
    }

  } else {
    if (data?.amount === 0) {
      res['message'] = 'Min amount can not be 0';
      res['status'] = false;
      return res;
    }
  }
  res['message'] = '';
  res['status'] = true;
  return res;
}

const Helpers = {
  keyDownFunction,
  getTokenData,
  nFormatter,
  betValidation
}

export default Helpers;